import axios from 'axios';
import Cookies from 'js-cookie';
import c from './course-helper';
import { $, endPoint, dataExist } from '../utils/Utils';

const cart = (() => {
  const $cart = $('.js-cart');
  const $submit = document.querySelector('.js-cartSubmit');
  const $count = document.querySelector('.js-cartCourseCount');
  const $total = document.querySelector('.js-cartTotal');

  const clear = () => {
    Cookies.remove('courses');
  };

  const get = () => ((Cookies.get('courses')) ? JSON.parse(Cookies.get('courses')) : []);

  const hasItem = id => get().indexOf(parseFloat(id)) > -1;

  const hasBundle = (id) => {
    const cookie = cart.get();
    const bundlesInCart = c
    // get all bundles from end point
      .get()
    // check if bundle is the cart
      .filter(course => cookie.indexOf(course.id) > -1)
    // check if course is part of bundle
      .filter(item => item.bundle.indexOf(id) > -1);

    return bundlesInCart.length > 0;
  };

  const update = (arr) => {
    Cookies.set('courses', arr, { expires: 7 });
    // get cart and update
    fetch();
  };

  const updateMarkup = (data) => {
    if (dataExist(data, 'count')) {
      $count.textContent = data.count;
    }
    if (dataExist(data, 'total')) {
      $total.textContent = data.total;
    }
  };

  const fetch = () => {
    // change button state
    $submit.classList.add('-loading');

    // update the cart
    axios
      .get(endPoint.cart)
      .then((response) => {
        // remove loading state
        $submit.classList.remove('-loading');

        // update cart markup
        updateMarkup(response.data);
      });
  };

  const add = (trigger) => {
    // get items in cart
    let cookie = cart.get();
    // get value from trigger
    const val = parseFloat(trigger.value);

    // do you want to add or remove from cart?
    if (trigger.checked) { // add
      // make sure the item is not already in the cart
      if (cookie.indexOf(val) < 0) {
        cookie.push(val);
      } else {
        // stop there, the item is already included in the cart
        return false;
      }
    } else { // remove
      cookie = cookie.filter(item => item !== val);
    }

    // update cookies
    update(cookie);
  };

  const checkoutRedirect = (e) => {
    // do not redirect if the cart is empty
    if (get().length < 1) {
      e.preventDefault();
    }
  };

  const compensatePadding = () => {
    // add some padding to the footer for the cart
    document.body.style.paddingBottom = `${$cart[0].clientHeight}px`;
  };

  const init = () => {
    if ($cart.length > 0) {
      $submit.addEventListener('click', e => checkoutRedirect(e));

      compensatePadding();
    }
  };

  return {
    init,
    get,
    hasItem,
    hasBundle,
    fetch,
    update,
    add,
    clear,
    reset: clear,
  };
})();

cart.init();

export default cart;



// WEBPACK FOOTER //
// ./components/cart.js